export default __webpack_public_path__ + "static/media/appreservas.b18c066c.png";